(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-tint-package-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
function initTintGuide(){
 const root=document.getElementById('sc-tint-guide');if(!root||root.dataset.tintReady)return;root.dataset.tintReady='true';
 const shades={dyed:[20,35,50],ceramic:[25,35,55,70]};
 const previews={dyed:[20,35,50,90],ceramic:[25,35,55,70,90]};
 const quoteFilm=root.querySelector('#tq-film'),quoteShade=root.querySelector('#tq-shade');
 function updateQuoteShade(preferred){
  const values=shades[quoteFilm.value.toLowerCase()]||[];
  quoteShade.replaceChildren(new Option(values.length?'Choose percentage':'Choose film first',''));
  values.forEach(value=>quoteShade.add(new Option(value+'%',value+'%')));
  quoteShade.add(new Option('Help me choose','Help me choose'));
  if(preferred===90)quoteShade.value='Help me choose';
  else if(preferred&&values.includes(parseInt(preferred,10)))quoteShade.value=parseInt(preferred,10)+'%';
 }
 quoteFilm.addEventListener('change',()=>updateQuoteShade());updateQuoteShade();
 root.querySelectorAll('.tv-package').forEach(card=>{
  const film=card.querySelector('.tv-preview-film'),slider=card.querySelector('.tv-shade-slider'),readout=card.querySelector('.tv-shade-readout'),stops=card.querySelector('.tv-shade-stops');
  function draw(){
   const percent=previews[film.value][Number(slider.value)];
   card.querySelector('.tv-ceramic-callout').hidden=film.value!=='ceramic';
   card.querySelector('.tv-window-tint').setAttribute('opacity',(Math.max(0,1-percent/90)*0.9).toFixed(3));
   card.querySelectorAll('[data-film]').forEach(cell=>cell.classList.toggle('tv-selected-price',cell.dataset.film===film.value));
   readout.textContent=percent+'%'+(percent===90?' ref.':'');
   slider.setAttribute('aria-valuetext',percent===90?'90 percent factory-glass reference; no added film':percent+' percent '+film.value+' film');
  }
  function configure(){
   const options=previews[film.value];slider.max=options.length-1;slider.value=options.indexOf(35);
   stops.replaceChildren(...options.map(p=>{const span=document.createElement('span');span.textContent=p+'%';if(p===90){const small=document.createElement('small');small.textContent='Factory-glass reference';span.appendChild(small);}return span;}));draw();
  }
  film.addEventListener('change',configure);slider.addEventListener('input',draw);
  card.querySelector('[data-tint-package]').addEventListener('click',()=>{
   root.querySelector('#tq-package').value=card.querySelector('.tv-package-size').value;
   quoteFilm.value=film.value==='dyed'?'Dyed':'Ceramic';updateQuoteShade(previews[film.value][Number(slider.value)]);
  });configure();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initTintGuide);else initTintGuide();
document.addEventListener('shopify:section:load',initTintGuide);
})();

  } catch(e) { console.error(e); }
})();
})();
